<template>
  <a-card :bordered="false">
    <search-page-view
      ref="pageList"
      rowKey="customSubjectMerchantId"
      :itemNames="['name_1','name_2']"
      :columns="getColumns()"
      :col="4"
      :queryParams="queryParams"
      :requestPromise="getListPromise"
    >
      <a-form-item slot="name_1" label="商品ID" v-bind="searchItemLayout">
        <a-input v-model="queryParams.productId" placeholder="请输入"></a-input>
      </a-form-item>
      <a-form-item slot="name_2" label="商品名称" v-bind="searchItemLayout">
        <a-input v-model="queryParams.productName" placeholder="请输入"></a-input>
      </a-form-item>
    </search-page-view>
  </a-card>
</template>

<script>
import searchForm from '../../../../utils/mixins/searchFormMixins'
import formMixin from '../../../../utils/mixins/formMixins'
import ErpDirectAssistantMixins from './ErpDirectAssistantMixins'

export default {
  name: 'SynchronizeProducts',
  components: {},
  mixins: [searchForm, formMixin, ErpDirectAssistantMixins],
  data() {
    return {
      queryParams: {},
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      searchItemLayout: {
        labelCol: { span: 7 },
        wrapperCol: { span: 17 }
      }
    }
  },
  created() {
    this.queryParams.merchantId = this.$store.getters.userInfo.merchantId
  },
  mounted() {

  },
  methods: {
    getListPromise(params) {
      return this.getHttpServices().getProService().post('/v1/kunlun/product/all', params)
    },
    getColumns() {
      return [
        {
          title: '产品ID（ERP）',
          dataIndex: 'proProductUrl',
          width: '150px'
        },
        {
          title: '产品名称',
          dataIndex: 'proName',
          width: '40%'
        },
        {
          title: '同步时间',
          dataIndex: 'proCreateTime'
        },
        {
          title: '更新时间',
          dataIndex: 'proUpdateTime'
        }
      ]
    }
  }
}
</script>
<style scoped lang="less">
</style>